/* global Promise */
import angular from 'angular';

export default function EditCustomRiskControlQuestionDialogController(
  $q,
  $scope,
  alerts,
  loaderService,
  userService,
  ssDialogService,
  vmDataService
) {
  const vm = this;

  vm.newRiskControlQuestion = { ...vm.riskControlQuestion };
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditCustomRiskControlQuestionFormSubmit = _handleEditCustomRiskControlQuestionFormSubmit;

  /** ********************************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditCustomRiskControlQuestionFormSubmit() {
    if ($scope.editCustomRiskControlQuestionForm.$invalid) {
      return Promise.resolve();
    }
    const isNew = vm.newRiskControlQuestion.riskControlQuestionId < 0;

    if (!isNew && angular.equals(vm.riskControlQuestion, vm.newRiskControlQuestion)) {
      // No need to save
      return _closeDialog(); // or return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return vmDataService.saveCustomRiskControlQuestion(vm.newRiskControlQuestion)
      .then((response) => {
        const savedQuestion = response.data;

        angular.extend(vm.newRiskControlQuestion, savedQuestion);
        angular.extend(vm.riskControlQuestion, vm.newRiskControlQuestion);
        if (isNew) {
          vm.addCallback(vm.riskControlQuestion);
        }
        return _closeDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while saving the Question.');
        _setFormUnsubmitted();
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** ********************************************************
   * Private Functions
   */

  function _setFormUnsubmitted() {
    $scope.editCustomRiskControlQuestionForm.$setPristine();
    $scope.editCustomRiskControlQuestionForm.$setUntouched();
  }


  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editCustomRiskControlQuestionDialog);
  }
}

EditCustomRiskControlQuestionDialogController.$inject = [
  '$q',
  '$scope',
  'alerts',
  'loaderService',
  'userService',
  'ssDialogService',
  'vmDataService'
];
